import React from 'react';
import { useSelector } from 'react-redux';
import { TableRow, TableCell, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';

import { ActionButtons } from 'containers/ChaptersPage/PendingChapterRequests/ActionButtons';
import LocationObject from 'entities/locationObject/model';
import { selectUser } from 'entities/user/selectors';
import { renderAddress } from 'utils/renderAddress';
import { useRevokeChapterRequestMutation } from 'generated/graphql';

interface ChapterRequest {
  id: string;
  nonprofitName: string;
  locationObject: LocationObject;
  createdAt: string;
  status: string;
  email: string;
  parentName: string;
  users: { email: string }[];
}

const ChapterRequestRow = ({
  chapterRequest,
  refetchChapterRequests,
  selectChapterRequest,
}: {
  chapterRequest: ChapterRequest;
  refetchChapterRequests: () => void;
  selectChapterRequest: (chapterRequest) => void;
}) => {
  const user = useSelector(selectUser);

  const [revokeChapterRequestMutation, { loading: revoking }] = useRevokeChapterRequestMutation();

  if (!user) {
    return null;
  }

  const { id, nonprofitName, locationObject, createdAt, status, users, parentName } =
    chapterRequest;

  const actionButtonDisabled = status !== 'Pending';

  const { isAdmin } = user;

  const reviewButton = actionButtonDisabled ? (
    <Button disabled={actionButtonDisabled}>Review</Button>
  ) : (
    <Link to={`pending/${id}`}>
      <Button>Review</Button>
    </Link>
  );

  const action = isAdmin ? (
    reviewButton
  ) : (
    <ActionButtons
      updating={revoking}
      disabled={actionButtonDisabled}
      chapterRequestName={nonprofitName}
      handleEdit={() => {
        selectChapterRequest(chapterRequest);
      }}
      handleRevoke={() => {
        revokeChapterRequestMutation({
          variables: {
            id: chapterRequest.id,
          },
          onCompleted: () => refetchChapterRequests(),
        });
      }}
    />
  );

  return (
    <TableRow style={{ height: 60 }}>
      {isAdmin && <TableCell>{parentName}</TableCell>}
      <TableCell>{nonprofitName}</TableCell>
      <TableCell>{renderAddress(locationObject)}</TableCell>
      <TableCell>{format(new Date(createdAt), 'MMM d, yyyy')}</TableCell>
      <TableCell>{status === 'Pending' ? status : 'Processing'}</TableCell>
      <TableCell>{users.length > 0 && users[0].email}</TableCell>
      <TableCell>{action}</TableCell>
    </TableRow>
  );
};

export default ChapterRequestRow;
